import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { Address } from './addresses/Address';
export class OrganizationSimple extends AutoEncoder {
}
__decorate([
    field({ decoder: StringDecoder })
], OrganizationSimple.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], OrganizationSimple.prototype, "name", void 0);
__decorate([
    field({ decoder: Address })
], OrganizationSimple.prototype, "address", void 0);
//# sourceMappingURL=OrganizationSimple.js.map